import React, { useLayoutEffect, useState } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IStaticHeaderSpacerProps extends IBaseElementProps {
	height?: number;
}
// This to be used when the Header is not stickied.
// For example on ResourceIndex when the filter style is Vertical
// Then watch for page resize and update the top margin accordingly.
/**
 * Spacer
 * @block
 * @icon move
 */
const StaticHeaderSpacer: React.FC<IStaticHeaderSpacerProps> = ({
	height = 0,
	id,
	className,
	classNames = [],
}) => {
	const [generatedHeight, setGeneratedHeight] = useState<number>(height || 0);
	useLayoutEffect(() => {
		const header = document.querySelector('.calian-header') as HTMLElement;
		if (header) {
			const headerHeight = header.clientHeight;

			setGeneratedHeight(headerHeight);
			const handleResize = () => {
				const headerHeight = header.clientHeight;
				setGeneratedHeight(headerHeight);
			};
			window.addEventListener('resize', handleResize);
			return () => {
				window.removeEventListener('resize', handleResize);
			};
		}
	}, []);

	return (
		<div
			id={id}
			className={
				className ||
				cn('calian-header-spacer d-none d-sm-block', ...classNames)
			}
			style={{ height: `${generatedHeight + 16}px` }}
		></div>
	);
};

export default StaticHeaderSpacer;
